import axios from "axios";
import DatosFormulario from "./datos-formulario";
import ValidadorFormulario from "./validador-formulario";
import tr from "./idiomas/es";
import Selects from "./componentes-html/selects";

class FormularioDonacion {

    constructor(captcha) {
        this.datos = {};
        this.captcha = captcha;
        this.multiplesDestinatarios = multiplesDestinatarios;
        this.stripePublicKey = '';
        this.stripeSessionId = '';

        const urlParams = new URLSearchParams(window.location.search);
        this.destinatarioDonacion = urlParams.get('ong') || '';
        console.log(this.destinatarioDonacion);

        this.setup();
        this.cargarListaPaises();
        this.cambiarVisibilidadSeccionesAlRecargar();
    }

    setup() {
        this.domElement = document.getElementById("fdemergencias-formulario-donacion");

        this.domElement.addEventListener('submit', (e) => { this.procesarFormulario(e) })

        this.domElementosCambiarSeccion = document.querySelectorAll('input[data-click="cambiar-seccion"]')
        this.domElementosCambiarSeccion.forEach(elemento => {
            elemento.addEventListener('click', (elemento) => {
                let tipoSeccion = elemento.target.getAttribute('data-click-tipo-seccion')
                let seccion = elemento.target.getAttribute('data-seccion-elegida')
                this.cambiarVisibilidadSeccion(tipoSeccion, seccion)
            })
        })

        this.domElementosToggle = document.querySelectorAll('input[data-click="toggle-seccion"]')
        this.domElementosToggle.forEach(elemento => {
            elemento.addEventListener('click', (elemento) => {
                let seccion = elemento.target.getAttribute('data-seccion-elegida')
                this.toggleSeccion(seccion, elemento.target.checked)
            })
        })

        this.domSelectsPais = document.querySelectorAll('[name="pais"]')
        this.domSelectsPais.forEach(elemento => {
            elemento.addEventListener('change', (elemento) => {
                let idPais = elemento.target.value;
                this.cargarListaProvincias(idPais)
            })
        })

        console.log("Destinatario: " + this.destinatarioDonacion)
        if (this.multiplesDestinatarios && !this.destinatarioDonacion) {
            document.getElementById('fdemergencias-privacidad').classList.add('hidden');
            document.getElementById('fdmergencias-boton-siguiente').classList.remove('hidden');
            document.getElementById('fdmergencias-boton-pagar').classList.add('hidden');
        }
    }

    cargarListaPaises() {
        let selectsPais = new Selects({name: 'pais'});
        selectsPais.cargando('Cargando países...');

        axios.get('/wp-json/fdemergencias/v1/donacion/lista-paises')
            .then(respuesta => {
                selectsPais.opciones(respuesta.data.paises);
            })
            .catch(error => {
                console.log(error)
            })
    }

    cargarListaProvincias(idPais) {
        let selectsProvincia = new Selects({name: 'provincia'});
        selectsProvincia.cargando('Cargando provincias...');

        axios.get('/wp-json/fdemergencias/v1/donacion/lista-provincias?pais=' + idPais)
            .then(respuesta => {
                selectsProvincia.opciones(respuesta.data.provincias);
            })
            .catch(error => {
                console.log(error)
            })
    }

    cambiarVisibilidadSeccion(tipoSeccion, seccion) {
        document.querySelectorAll('[data-tipo-seccion="' + tipoSeccion + '"]').forEach((seccion) => {
            seccion.classList.add('hidden')
        })
        document.querySelector('[data-seccion="' + seccion + '"]').classList.remove('hidden')
    }

    toggleSeccion(seccion, nuevoEstado) {
        let elemento = document.querySelector('[data-seccion="' + seccion + '"]');
        if (nuevoEstado) {
            elemento.classList.remove('hidden')
        }
        else {
            elemento.classList.add('hidden')
        }
    }

    cambiarVisibilidadSeccionesAlRecargar() {
        document.querySelectorAll('input[data-click="cambiar-seccion"]:checked').forEach(elemento => {
            let tipoSeccion = elemento.getAttribute('data-click-tipo-seccion')
            let seccion = elemento.getAttribute('data-seccion-elegida')
                this.cambiarVisibilidadSeccion(tipoSeccion, seccion)
        })
        document.querySelectorAll('input[data-click="toggle-seccion"]:checked').forEach(elemento => {
            let tipoSeccion = elemento.getAttribute('data-click-tipo-seccion')
            let seccion = elemento.getAttribute('data-seccion-elegida')
            this.cambiarVisibilidadSeccion(tipoSeccion, seccion)
        })
    }

    procesarFormulario(e) {
        e.preventDefault();

        this.recogerDatosFormulario();
        this.validarFormulario();
        this.limpiarErrores();
        this.mostrarErrores();

        this.enviarFormulario();
        this.mostrarFormularioStripe();

    }

    recogerDatosFormulario() {
        let datosFormulario = new DatosFormulario();
        this.datos = datosFormulario.get();
    }

    validarFormulario() {
        let validador = new ValidadorFormulario(this.datos)
        let politicaPrivadicadObligatoria = true;
        if (this.multiplesDestinatarios && this.destinatarioDonacion==='') {
            politicaPrivadicadObligatoria = false;
        }
        this.errores = validador.validar(politicaPrivadicadObligatoria);
    }

    limpiarErrores() {
        document.querySelectorAll('[data-mensajes]').forEach(elemento => {
            elemento.classList.add('hidden')
        })
    }

    mostrarErrores() {
        this.errores.forEach(error => {
            let elementoDom = document.querySelector('[data-mensajes="' + error.campo + '"]')
            elementoDom.innerHTML = error.mensaje;
            elementoDom.classList.remove('hidden')
        })
    }

    enviarFormulario() {
        if (this.errores.length) {
            console.log(this.errores)
            return;
        }

        this.mostrarAlUsuarioElProgreso();

        this.datos.recaptcha = this.captcha.getCodigoRecatpcha();
        console.log(this.captcha)

        if (!this.datos.recaptcha) {
            this.errores.push({campo: 'formulario-donacion', mensaje: 'Ha fallado el recaptcha'})
            this.mostrarErrores();
            this.volverFormularioAlEstadoSinEnviar();
            return;
        }

        if (!this.destinatarioDonacion) {
            // Buscar destinatario
            axios.post('/wp-json/fdemergencias/v1/donacion/buscar-destinatario-donacion', this.datos)
                .then(respuesta => {
                    this.destinatarioDonacion = respuesta.data.destinatarioDonacion;
                    document.getElementById('fdemergencias-privacidad').classList.remove('hidden');
                    document.getElementById('fdmergencias-boton-siguiente').classList.add('hidden');
                    document.getElementById('fdmergencias-boton-pagar').classList.remove('hidden');
                    document.getElementById('fdemergencias-url-privacidad').setAttribute('href', this.urlPoliticaPrivacidad);
                    document.getElementById('fdemergencias-seccion-formulario').classList.add('hidden');

                    let otrasFormasDonacion = respuesta.data.metodosPagoAdicionales;
                    if (otrasFormasDonacion.bizum || otrasFormasDonacion.transferencia) {
                        document.getElementById('fdemergencias-bizum-telefono').innerHTML = otrasFormasDonacion.bizum;
                        document.getElementById('fdemergencias-transferencia-cuenta').innerHTML = otrasFormasDonacion.transferencia;
                        document.getElementById('fdemergencias-metodos-pago-adicionales').classList.remove('hidden');
                        document.getElementById('fdemergencias-url-privacidad').setAttribute('href', respuesta.data.url_privacidad);
                    }
                });
            return;
        }

        axios.post('/wp-json/fdemergencias/v1/donacion', this.datos)
            .then(respuesta => {
                this.stripePublicKey = respuesta.data.stripePublicKey;
                this.stripeSessionId = respuesta.data.stripeSessionId;
                this.urlPoliticaPrivacidad = respuesta.data.urlPoliticaPrivacidad;
                this.metodosPagoAdicionales = respuesta.data.metodosPagoAdicionales;
                document.cookie = "codigoDonacion=" + respuesta.data.codigoDonacion + "; path=/";

                var stripe = Stripe(this.stripePublicKey);
                var result = stripe.redirectToCheckout({ sessionId: this.stripeSessionId });
                return;

            })
            .catch(error => {
                console.log(error);
                if (typeof error.response.data.message.error !=='undefined') {
                    this.errores.push({campo: 'formulario-donacion', mensaje: error.response.data.message.error})
                }
                else {
                    this.errores.push({campo: 'formulario-donacion', mensaje: 'Error enviando el formulario'})
                }
                this.mostrarErrores();
                this.volverFormularioAlEstadoSinEnviar();
            })
    }

    mostrarAlUsuarioElProgreso() {
        const botones = document.querySelector('[data-boton="enviar"]');
        botones.innerHTML = tr.formulario.botonEnviando;
        botones.disabled = true;
    }

    volverFormularioAlEstadoSinEnviar() {
        const botones = document.querySelector('[data-boton="enviar"]');
        botones.innerHTML = tr.formulario.botonEnviar;
        botones.disabled = false;
    }

    mostrarFormularioStripe() {

    }

}

export default FormularioDonacion;